import React from 'react'

const MyAccountCard = ({ item, onClick }) => {
  return (
    <div className="accountcard" onClick={onClick}>
      {item.icon && <span className="accountcard__icon">{item.icon}</span>}
      <h1 className="accountcard__title">{item.title}</h1>
      <p className="accountcard__subtitle">{item.info}</p>
      <p className="accountcard__desc">{item.description}</p>
    </div>
  )
}

export default MyAccountCard
